import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bnEmpty' })
export class BnEmptyPipe implements PipeTransform {
  transform(value: string, empty = '--'): string {
    return value === null || value === undefined || value === '' || value === '-1' ? empty : value;
  }
}
